import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalService} from "../../../../services/modal.service";

@Component({
  selector: 'app-reset-password-dialog',
  templateUrl: './reset-password-dialog.component.html',
  styleUrls: ['./reset-password-dialog.component.scss']
})
export class ResetPasswordDialogComponent {
  @Input() selectedUser: number[] = []
  @Input() userName: string | undefined
  @Input() userId: number | undefined

  @Output() resetPasswordEvent: EventEmitter<string> = new EventEmitter<string>()

  constructor(
    private modalService: ModalService
  ) {
  }

  closeModal() {
    this.modalService.closeModal()
  }

  resetPassword() {
    let userIds: string
    if (this.selectedUser.length === 0 && this.userId) {
      userIds = this.userId.toString()
    } else {
      userIds = this.selectedUser.join(',')
    }
    this.resetPasswordEvent.emit(userIds)
    this.closeModal()
  }
}
